module.exports = __webpack_public_path__ + "static/img/logo.bd61e51.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/logo.png
// module id = 8Fi2
// module chunks = 11